import type { Message } from "./MessageRow";
import type { AsyncMessageItem } from "./network/useAsyncMessageInbox";

// sorting pinned messages to the beginning of the messages array & appending `pinned` boolean for MessageRow.tsx prop interface
export const sortPinnedMessages = (
  messages: AsyncMessageItem[] | undefined,
  pinnedPatients: string[] | undefined,
) => {
  if (!messages) return [];

  const { pinned, unpinned } = messages.reduce<{
    pinned: Message[];
    unpinned: Message[];
  }>(
    (acc, message) => {
      const isPinned = pinnedPatients?.includes(message.patient.id);
      const updatedMessage = { ...message, pinned: isPinned };

      if (isPinned) acc.pinned.push(updatedMessage);
      else acc.unpinned.push(updatedMessage);
      return acc;
    },
    { pinned: [], unpinned: [] },
  );

  return [...pinned, ...unpinned];
};
